import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

// import mui
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import frankfurt from "../assets/travel/frankfurt.jpg";
import baden from "../assets/travel/baden.jpg";
import rudesheim from "../assets/travel/rudesheim.jpg";
import konstanz from "../assets/travel/konstanz.jpg";
import basel from "../assets/travel/basel.jpg";
import strassburg from "../assets/travel/strassburg.jpg";
import neuschwanstein from "../assets/travel/neuschwanstein.jpg";
import munich from "../assets/travel/munich.jpg";
import plane from "../assets/travel/plane.jpg";

// component
const Traveling = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const travelDays = [
    {
      day: t("travel_day_1"),
      date: "5.Juli",
      title: t("travel_day_1_title"),
      description: t("travel_day_1_description"),
      image: frankfurt,
    },
    {
      day: t("travel_day_2"),
      date: "6.Juli",
      title: t("travel_day_2_title"),
      description: t("travel_day_2_description"),
      image: baden,
    },
    {
      day: t("travel_day_3"),
      date: "7.Juli",
      title: t("travel_day_3_title"),
      description: t("travel_day_3_description"),
      image: rudesheim,
    },
    {
      day: t("travel_day_4"),
      date: "8.Juli",
      title: t("travel_day_4_title"),
      description: t("travel_day_4_description"),
      image: konstanz,
    },
    {
      day: t("travel_day_5"),
      date: "9.Juli",
      title: t("travel_day_5_title"),
      description: t("travel_day_5_description"),
      image: basel,
    },
    {
      day: t("travel_day_6"),
      date: "10.Juli",
      title: t("travel_day_6_title"),
      description: t("travel_day_6_description"),
      image: strassburg,
    },
    {
      day: t("travel_day_7"),
      date: "11.Juli",
      title: t("travel_day_7_title"),
      description: t("travel_day_7_description"),
      image: neuschwanstein,
    },
    {
      day: t("travel_day_8"),
      date: "12.Juli",
      title: t("travel_day_8_title"),
      description: t("travel_day_8_description"),
      image: munich,
    },
    {
      day: t("travel_day_9"),
      date: "13.Juli",
      title: t("travel_day_9_title"),
      description: t("travel_day_9_description"),
      image: plane,
    },
  ];

  return (
    <div>
      <Box className="main_container">
        <Container maxWidth="lg">
          <Box className="section_container">
            <Typography
              variant="h3"
              component="h3"
              gutterBottom
              align="center"
              sx={{ mb: 6, fontWeight: "bold" }}
            >
              {t("traveling.tour_package_title")}
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ mb: 4 }}>
              {t("traveling.tour_package_intro")}
              <br />
              {t("traveling.tour_package_point1")}
              <br />
              {t("traveling.tour_package_point2")}
              <br />
              {t("traveling.tour_package_point3")}
              <br />
              {t("traveling.tour_package_point4")}
            </Typography>

            {travelDays.map((day, index) => (
              <Card key={day.day} sx={{ mb: 4, borderRadius: 2, boxShadow: 3 }}>
                <Grid container spacing={0}>
                  <Grid item xs={12} md={6}>
                    <CardMedia
                      component="img"
                      height="400"
                      image={day.image}
                      alt={day.day}
                      sx={{ objectFit: "cover" }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CardContent sx={{ p: 4 }}>
                      <Typography variant="h4" gutterBottom color="primary">
                        {day.day}
                      </Typography>
                      <Typography variant="h5" gutterBottom>
                        {day.title}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {day.description}
                      </Typography>
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Box>
        </Container>
      </Box>
    </div>
  );
};

export default Traveling;
